import {
  FranchiseType,
  ProductCategoryType,
  PropositionAllocation,
} from "@hubcapp/types";

/*
In the UI, we group area coverage by franchise type rather than
by product category (as it is defined in the DB).
The DB stores regional pricing, instructor pricing and discounts
by product category so we need to fetch said data via a product category.
This method gets the default product category for a franchise, as decided
by the Product team
*/
export const getDefaultFranchiseProductCategory = (
  franchise: PropositionAllocation,
) => {
  const propositionType = franchise.proposition.type;
  if (propositionType === FranchiseType.Dit) {
    return ProductCategoryType.DitCar;
  }

  if (propositionType === FranchiseType.Motability) {
    const isFranchiseMotability2018 = franchise.proposition.productCategories?.some(
      category => category.type === ProductCategoryType.Motability2018,
    );

    if (isFranchiseMotability2018) {
      return ProductCategoryType.Motability2018;
    }

    return ProductCategoryType.Motability2015;
  }

  return ProductCategoryType.PreTest;
};
